/* Horizontale slider op basis van scroll-snap.
   Verwacht binnenin: [data-spoor], optioneel [data-vorige], [data-volgende] en [data-balk]. */
class AsnSlider extends HTMLElement {
  connectedCallback() {
    this.spoor = this.querySelector('[data-spoor]');
    if (!this.spoor) return;

    this.vorige = this.querySelector('[data-vorige]');
    this.volgende = this.querySelector('[data-volgende]');
    this.balk = this.querySelector('[data-balk]');

    this.vorige?.addEventListener('click', () => this.schuif(-1));
    this.volgende?.addEventListener('click', () => this.schuif(1));

    this.werkbij = this.werkbij.bind(this);
    this.spoor.addEventListener('scroll', this.werkbij, { passive: true });
    window.addEventListener('resize', this.werkbij, { passive: true });
    this.werkbij();

    if (this.dataset.auto === 'aan') this.startAuto();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.werkbij);
    clearInterval(this.autoTimer);
  }

  /* Automatisch doorlopen. Stopt zodra de bezoeker zelf iets doet, pauzeert
     bij aanwijzen en als het tabblad op de achtergrond staat. */
  startAuto() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.tempo = parseInt(this.dataset.tempo, 10) || 4000;
    this.gepauzeerd = false;

    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach((gebeurtenis) => {
      this.spoor.addEventListener(gebeurtenis, () => this.stopAuto(), { passive: true, once: true });
    });
    this.vorige?.addEventListener('click', () => this.stopAuto(), { once: true });
    this.volgende?.addEventListener('click', () => this.stopAuto(), { once: true });

    this.addEventListener('mouseenter', () => { this.gepauzeerd = true; });
    this.addEventListener('mouseleave', () => { this.gepauzeerd = false; });

    this.autoTimer = setInterval(() => this.autoStap(), this.tempo);
  }

  stopAuto() {
    clearInterval(this.autoTimer);
    this.autoTimer = null;
  }

  autoStap() {
    if (this.gepauzeerd || document.hidden) return;
    const max = this.spoor.scrollWidth - this.spoor.clientWidth;
    if (max <= 2) return;

    const eerste = this.spoor.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.spoor).columnGap) || 0;
    const stap = eerste ? eerste.offsetWidth + gap : this.spoor.clientWidth;
    const naar = this.spoor.scrollLeft + stap;
    this.spoor.scrollTo({ left: naar > max - 2 ? 0 : naar, behavior: 'smooth' });
  }

  get stap() {
    const eerste = this.spoor.firstElementChild;
    if (!eerste) return this.spoor.clientWidth;
    const gap = parseFloat(getComputedStyle(this.spoor).columnGap) || 0;
    // per klik ongeveer een scherm vol kaarten, maar altijd minstens één kaart
    const kaart = eerste.offsetWidth + gap;
    const passen = Math.max(1, Math.floor(this.spoor.clientWidth / kaart));
    return kaart * passen;
  }

  schuif(richting) {
    this.spoor.scrollBy({ left: this.stap * richting, behavior: 'smooth' });
  }

  werkbij() {
    const max = this.spoor.scrollWidth - this.spoor.clientWidth;
    const pos = this.spoor.scrollLeft;

    if (this.vorige) this.vorige.disabled = pos <= 2;
    if (this.volgende) this.volgende.disabled = pos >= max - 2;

    if (this.balk) {
      const deel = this.spoor.clientWidth / this.spoor.scrollWidth;
      const breedte = Math.min(1, deel) * 100;
      const verplaatsing = max > 0 ? (pos / max) * (100 - breedte) : 0;
      this.balk.style.width = breedte + '%';
      this.balk.style.transform = `translateX(${(verplaatsing / breedte) * 100}%)`;
    }

    this.classList.toggle('asn-slider--vol', max <= 2);

    // Een gebied dat kan scrollen moet met het toetsenbord bereikbaar zijn.
    if (max > 2) {
      this.spoor.setAttribute('tabindex', '0');
      if (!this.spoor.hasAttribute('aria-label')) {
        this.spoor.setAttribute('aria-label', this.dataset.label || 'Horizontale lijst, scroll met de pijltjestoetsen');
      }
    } else {
      this.spoor.removeAttribute('tabindex');
    }
  }
}

/* Ook de rijen die zonder slider horizontaal scrollen (categorie-rij, chips,
   pluspunten-balk) hebben toetsenbordtoegang nodig zodra ze overlopen. */
function scrollbareRijen() {
  document.querySelectorAll('.asn-catrow, .asn-chips, .asn-uspbar__lijst, .asn-academy__lijst').forEach((el) => {
    const loopt = el.scrollWidth - el.clientWidth > 2 || el.scrollHeight - el.clientHeight > 2;
    if (loopt) {
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Lijst die je kunt scrollen');
    } else {
      el.removeAttribute('tabindex');
    }
  });
}

document.addEventListener('DOMContentLoaded', scrollbareRijen);
window.addEventListener('resize', scrollbareRijen, { passive: true });

customElements.define('asn-slider', AsnSlider);
